import React from "react";
import "./CheckoutFooter.css";
import { NFOLogo } from "../../../../Assets/svgs";

const CheckoutFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-child">
        <div className="footer-left">
          <img
            src={NFOLogo}
            alt="National Finance Olympiad Logo"
            className="footer-logo"
          />
          <div className="pockvue-solution-private-limited">
            Pockvue Solutions Private Limited
          </div>
          <a
            href="mailto:support@nationalfinanceolympiad.com"
            className="footer-email"
          >
            support@nationalfinanceolympiad.com
          </a>
          <a
            href="https://nationalfinanceolympiad.com/contact-us"
            className="send-us-a-message"
          >
            send us a message
          </a>
        </div>

        <div className="footer-right">
          <div className="footer-right-text">Other links</div>
          <a
            href="https://nationalfinanceolympiad.com/terms-conditions"
            className="footer-link"
          >
            Terms and Conditions
          </a>
          <a
            href="https://nationalfinanceolympiad.com/privacy-policy"
            className="footer-link"
          >
            Privacy Policy
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        © 2024 National Finance Olympiad | An initiative by Streak
      </div>
    </footer>
  );
};

export default CheckoutFooter;
